import { ProductImage } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductImage";
import { useProductImages } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/personal/__internal__/faire-direct/useProductImages";
import { LoadingSkeleton } from "@faire/web/slate-deprecated/LoadingSkeleton";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";

export const ProductImages: React.FC<{
  brandToken?: string;
  loadTimingRef?: React.RefCallback<HTMLElement>;
}> = ({ brandToken, loadTimingRef }) => {
  const MIN_NUMBER_OF_PRODUCTS_TO_DISPLAY = 2;
  const MAX_NUMBER_OF_PRODUCTS_TO_DISPLAY = 3;

  const { isMobile } = useViewport();
  const { productImages, isPending } = useProductImages(
    brandToken,
    MAX_NUMBER_OF_PRODUCTS_TO_DISPLAY
  );
  if (!brandToken) {
    return null;
  }

  if (
    !isPending &&
    (!productImages || productImages.length < MIN_NUMBER_OF_PRODUCTS_TO_DISPLAY)
  ) {
    if (isMobile) {
      return <Spacer height="4x" />;
    }
    return null;
  }

  return (
    <Column>
      <ImagesContainer ref={loadTimingRef}>
        {isPending && !productImages ? (
          <>
            <Column flex={1}>
              <LoadingSkeleton width="100%" height="" aspectRatio="1" />
            </Column>
            <Column flex={1}>
              <LoadingSkeleton width="100%" height="" aspectRatio="1" />
            </Column>
            <Column flex={1}>
              <LoadingSkeleton width="100%" height="" aspectRatio="1" />
            </Column>
          </>
        ) : null}
        {productImages?.map((productImage, index) => (
          <Column key={productImage?.token ?? index} flex={1}>
            <ProductImage
              image={productImage}
              alt={productImage?.alt_text ?? "Product Image"}
            />
          </Column>
        ))}
      </ImagesContainer>
      <Spacer height="4x" />
    </Column>
  );
};

const ImagesContainer = styled(Row).attrs({ gap: 1, align: "center" })`
  width: 100%;
  overflow: hidden;

  ${responsiveMediaQueries.mobile} {
    max-height: 124px;
    margin-left: ${getSpacing("-3x")};
    width: calc(100% + ${getSpacing("6x")});
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    max-height: 160px;
  }
`;
